import {debounceTime} from 'rxjs/operators';
import {Component, OnInit, Input, OnChanges} from '@angular/core';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import { UntypedFormGroup, UntypedFormArray, Validators, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  TypesService,
  ProductService,
  FormBuilderService,
  CollateralService,
  NotificationService
} from '../../../services';
import {InvidualInsuranceModel, QuoteDetailsModel} from '../../../models/widgets/quote-details-model';
import {RateService, PricingInput, PricingOutput} from '../../../services';
import {Decimal} from 'decimal.js';
import _ from 'lodash';
import * as moment from 'moment';
import {DataHandlerService} from '../../../services/data-handler.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatOptionModule } from '@angular/material/core';
import { NgFor, NgIf } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import {
  CarSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/car-search/car-search.component';

@Component({
    selector: 'app-quote-details',
    templateUrl: './quote-details.component.html',
    styles: [],
    standalone: true,
    imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatFormFieldModule,
      MatSelectModule, MatSelectModule, NgFor, MatOptionModule, MatOptionModule, ValidationPartialComponent, NgIf, MatInputModule,
      MatInputModule, MatButtonModule, MatButtonModule, MatIconModule, MatCheckboxModule, MatCheckboxModule, CarSearchComponent]
})
export class QuoteDetailsComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public broker: any;
  @Input() public loanProduct: any;
  @Input() public featureSwitches: any[];

  public dialDownEnabled = true; // IMPT - FLAG to return back implementation of dial down UI

  public loanPurposes = [];
  public repaymentTypes = [];
  public loanTerms = [];
  public insurancePurposes = [];
  public allBalloons = [];
  public showHistorySearch = false;
  public showCarSearch = true; // set this to true by default
  public brokerageEnabled = true;
  public originatorEnabled = true;
  public showAddInsurance = false;
  public enableLoanTerms = false;
  public disableBalloons = true;
  public totalLoanAmount = 0;

  public insurancesFormArray: any;
  public variantTypes = [];
  public isGreen = false;
  public rateData: PricingOutput;

  private _loanPurposesTypesSlugs = ['car-loan-loan-purpose-types-vx'];
  private _securityType = 'new';
  private _motorLoanPurposeGroupIds = [1, 2];
  private _insurancePurposeGroupId = [5];
  private _purposesRequireHistorySearch = [
    'purchase-used-business',
    'purchase-used-personal',
    'refinance-personal',
  ];
  public vehicleAge: number = null;
  public loanTermInYears: number = null;
  private _selectedPurpose: any;
  private _collateral: any;
  private _loanTerm: any;
  private _subtotal = 0;
  private _totalFees = 0;
  private _totalInsurance = 0;
  private _brokerageUpdated = false;
  public minLoanAmountDisabled = true;

  constructor(public dataHandlerService: DataHandlerService,
              private typesService: TypesService,
              private productService: ProductService,
              private collateralService: CollateralService,
              private notificationService: NotificationService,
              private formBuilderService: FormBuilderService,
              private rateService: RateService) {
    super(dataHandlerService);
  }

  async ngOnInit() {
    this.minLoanAmountDisabled = (this.featureSwitches && this.featureSwitches.find(x => x.id === 'fits-3132_min-loan-amount') && !this.featureSwitches.find(x => x.id === 'fits-3132_min-loan-amount').ext.enabled) ? true : false;

    super.ngOnInit();

    await this.getDialDownFlag();

    this.populatePurposes();
    this.populateRepaymentTypes();
    this.initInsurance();
    this.initSubscriptions();
    this.calculateSubtotal();
    this.initCarSearch();
    this.initVariantSpecs();
  }


  getDialDownFlag() {
    return this.rateService.getDialDownEnabled().then((res) => {
      // check first the value of brokerage capitalization
      if (this.formGroup.value.brokerageFeeCapitalizedCheck !== null ||
        this.formGroup.value.brokerageFeeCapitalizedCheck !== undefined) {
        this.dialDownEnabled = !this.formGroup.value.brokerageFeeCapitalizedCheck;
      } else {
        // use the default
        this.dialDownEnabled = res;
      }
      this.toggleRateParameters();
    });
  }

  toggleDialDown(dialDownDisabled) {
    this.dialDownEnabled = !dialDownDisabled;
    this.toggleRateParameters();
  }

  toggleRateParameters() {
    this.rateService.setRateParameters({brokeragePaymentType: (this.dialDownEnabled) ? 'paid-by-funder' : 'funded'});
    this.updateMaxBrokerageAmount();
  }

  ngOnChanges(changes) {
    this.insurancesFormArray = <UntypedFormArray>this.formGroup.controls['insurances'];

    if (changes['formGroup'] && changes['formGroup']['firstChange']) {
      if (changes['formGroup']['currentValue']['value']['purpose']) {
        this.updateSelectedPurpose(changes['formGroup']['currentValue']['value']['purpose']);
      }
      if (changes['formGroup']['currentValue']['value']['vehicle']) {
        this._collateral = changes['formGroup']['currentValue']['value']['vehicle'];
        this.setVehicleAge();
        if (!this._collateral.text && changes['formGroup']['currentValue']['value']['description']) {
          this._collateral.text = changes['formGroup']['currentValue']['value']['description'];
        }
      }
      if (changes['formGroup']['currentValue']['value']['loanTerm']) {
        this._loanTerm = changes['formGroup']['currentValue']['value']['loanTerm'];
      }
    }

    this.getVxProducts();
    this.calculateBalloon();
  }

  retrieveVariants(slug) {
    if (slug && slug.endsWith('-tba')) {
      this.variantTypes = [];
      return;
    }
    this.collateralService.retrieveVariants(slug).subscribe((res: any) => {
      this.variantTypes = res;
    }, (err) => {
      console.log(err);
      this.variantTypes = [];
    });
  }

  public searchVin() {
    if (this.formGroup.get('vin').value) {
      this.formGroup.get('description').patchValue(null, {emitEvent: false});
      this.formGroup.get('odometer').patchValue(null, {emitEvent: false});
      this.collateralService.searchByVin(this.formGroup.get('vin').value)
        .subscribe((results) => {
          if (results.length > 1) {
            console.log('[processSearchByVin]', results);
            // get first element
            const latestMatch = results[results.length - 1];
            // TODO: handle multiple results?
            const carText = latestMatch['year'] + ' ' + latestMatch['make'] + ' ' + latestMatch['model'];
            this._collateral = {
              year: latestMatch['year'],
              make: latestMatch['make'],
              model: latestMatch['model'],
              text: carText,
              description: carText
            };

            this.setVehicleAge();

            // push these values to the rate service
            this.rateService.setRateParameters({
              year: this._collateral.year,
              make: this._collateral.make,
              model: this._collateral.model
            });

            this.formGroup.get('vehicle').patchValue(this._collateral);
            this.formGroup.get('odometer').patchValue(latestMatch['odometerReading'], {emitEvent: false});
            this.getVxProducts();
          } else {
            this.formGroup.get('vehicle').reset();
            if (this.formGroup.get('vehicle').get('text')) {
              this.formGroup.get('vehicle').get('text').markAsTouched();
              this.formGroup.get('vehicle').get('text').updateValueAndValidity();
            }
            this.notificationService.snackBar('Unable to find VIN / Chassis #. Please search for a car manually.', 'OK', 'warn-snackbar');
          }
        });
    }
  }

  /**
   * Initialize the variant specs if none was populated initially
   */
  initVariantSpecs() {
    if (!this.formGroup.value.specs && this.formGroup.value.variant) {
      this.getVariantSpecs({
        value: this.formGroup.value.variant
      });
    }
  }

  getVariantSpecs(event: any) {
    if (event.value && event.value !== 'null') {
      this.collateralService.retrieveSpecifications(event.value)
        .subscribe((response: any) => {
          this.formGroup.get('specs').patchValue(response, {emitEvent: false});
          this.rateService.setRateParameters({
            engineName: response.engineName,
            engineCapacity: response.ccName ? _.split(response.ccName, ' ')[0] : null,
            fuelName: response.fuelName,
            variantName: response.variantName,
            transmissionType: response.transmissionName
          });
        }, (err) => {
          console.log('Error during retrieving vehicle specs', err);
          this.rateService.setRateParameters({
            engineName: null,
            engineCapacity: null,
            fuelName: null,
            variantName: null,
            transmissionType: null
          });
        });
    } else {
      this.formGroup.get('variant').patchValue(null);
      this.formGroup.get('specs').patchValue(null);
      this.rateService.setRateParameters({
        engineName: null,
        engineCapacity: null,
        fuelName: null,
        variantName: null,
        transmissionType: null
      });
    }
  }

  public updateSelectedPurpose(data) {
    this._selectedPurpose = data;
    this.formGroup.get('purposeName').setValue(this.getPurposeNameBySlug(data), {emitEvent: false});
    this.setSecurityType(data);

    if (this._purposesRequireHistorySearch.includes(data)) {
      this.showHistorySearch = true;
      this.showCarSearch = false;
    } else {
      this.showHistorySearch = false;
      this.showCarSearch = true;
    }
  }

  setVehicleAge() {
    const comparisonYear: number = +(moment().format('YYYY'));
    this.vehicleAge = Math.abs(comparisonYear - this._collateral.year);
    this.checkValidation();
    console.log('this.vehicleAge', this.vehicleAge);
  }

  checkValidation() {
    console.log('vehicle age validation');

    let minLoanAmount;
    let maxLoanAmount;
    // Check if feature is enabled
    if(!this.minLoanAmountDisabled) {
      // Set min-max based on loan product data
      this.loanProduct.minLoan = 10000;
      minLoanAmount = _.get(this.loanProduct, 'minLoan');
      maxLoanAmount = _.get(this.loanProduct, 'maxLoan');
    } else {
      // Old static min-max loan amount
      minLoanAmount = 5000;
      maxLoanAmount = 50000;
    }

    if (this.vehicleAge >= 7) {
      console.log('vehicle is 7 years or older');
      this.formGroup.get('totalLoanAmount').setValidators([Validators.min(minLoanAmount), Validators.max(maxLoanAmount)]);
      this.formGroup.get('totalLoanAmount').updateValueAndValidity();
    } else {
      console.log('vehicle is less than 7 years old');
      this.formGroup.get('totalLoanAmount').clearValidators();
      this.formGroup.get('totalLoanAmount').setValidators([Validators.required]);
      this.formGroup.get('totalLoanAmount').updateValueAndValidity();
    }
  }

  initCarSearch() {
    this.formGroup.get('purpose').valueChanges.pipe(debounceTime(500)).subscribe((val) => {
      this.rateService.setRateParameters({
        primaryPurpose: val
      });
      this.getVxProducts();
    });
    this.formGroup.get('brokerageFee').valueChanges.pipe(debounceTime(500)).subscribe((val) => this.rateService.setRateParameters({brokerage: val}));
    this.formGroup.get('applicationFee').valueChanges.pipe(debounceTime(500)).subscribe((val) => this.rateService.setRateParameters({applicationFee: val}));
    this.formGroup.get('originationFee').valueChanges.pipe(debounceTime(500)).subscribe((val) => this.rateService.setRateParameters({originationFee: val}));
    this.formGroup.get('depositTradeAmount').valueChanges.pipe(debounceTime(500)).subscribe((val) => this.rateService.setRateParameters({depositAmount: val}));

    this.formGroup.valueChanges.pipe(debounceTime(500)).subscribe((val) => {
      let rateParams: PricingInput = {};
      // if there are changes to the selected collateral
      if (val.vehicle && val.vehicle.year &&
        JSON.stringify(this._collateral) !== JSON.stringify(val.vehicle)) {
        this._collateral = val.vehicle;

        this.setVehicleAge();

        // push these values to the rate service
        rateParams = Object.assign(rateParams, {
          year: this._collateral.year,
          make: this._collateral.make,
          model: this._collateral.model
        });
        this.formGroup.get('description').patchValue(val.text);
        this.getVxProducts();
        console.log('selected', val);
        this.retrieveVariants(val.vehicle.id);
        this.rateService.setRateParameters(rateParams);
      }
    });
    if (this.formGroup.value.vehicle && this.formGroup.value.vehicle.id) {
      this.retrieveVariants(this.formGroup.value.vehicle.id);
    }
    this.rateService.rateData.subscribe((val) => {
      console.debug('QuoteDetailsComponent.rateService.rateData');
      this.rateData = val;
      // console.log(val);
      if (val) {
        this.isGreen = val.IsGreen.toLowerCase() === 'true';
        // handle max brokerage amount
        this.toggleBrokerageFees(this.formGroup.value.brokerageFeeCheck);
      }
    });
  }

  updateMaxBrokerageAmount() {
    const max = _.get(this.rateData, 'MaxBrokerageAmountAvailable');
    if (!isNaN(max) && Number(max) && !this.formGroup.value.brokerageFeeCheck) {
      this.formGroup.get('brokerageFeePercentage').clearValidators();
      this.formGroup.get('brokerageFee').setValidators([Validators.min(1), Validators.required, Validators.max(Number(max))]);
    } else {
      this.formGroup.get('brokerageFee').setValidators([Validators.min(1), Validators.required]);
    }
    this.formGroup.get('brokerageFee').updateValueAndValidity({emitEvent: false});
    this.formGroup.get('brokerageFeePercentage').updateValueAndValidity({emitEvent: false});
  }

  initInsurance() {
    if (this.insurancesFormArray.length === 0) {
      this.addInsurance(0);
    }
  }

  addInsurance(index) {
    // console.log('[addInsurance]', index);
    const fg = this.formBuilderService.convertObjectToFormGroup(new InvidualInsuranceModel());
    this.formBuilderService.setValidationRules(new InvidualInsuranceModel(), fg);
    this.insurancesFormArray.push(fg);
  }

  removeInsurance(index) {
    this.insurancesFormArray.removeAt(index);
    // always keep 1
    if (this.insurancesFormArray.controls.length === 0) {
      this.addInsurance(0);
    }
    this.processInsurances();
  }

  populatePurposes() {
    this._loanPurposesTypesSlugs.forEach((slug) => {
      this.typesService.getTypesList(slug)
        .then((results) => {
          results.forEach((res) => {
            if (res.ext.Active) {
              if (this._motorLoanPurposeGroupIds.includes(res.ext.LoanPurposeGroupID) &&
                // WIZ-335 - remove business car loans from options
                !res.id.includes('business')) {
                res['productType'] = 'motor-vehicle';
                this.loanPurposes.push(res);
              } else if (this._insurancePurposeGroupId.includes(res.ext.LoanPurposeGroupID)) {
                this.insurancePurposes.push(res);
              } else {
                console.log('[WARN]', 'Unused purpose:', res.id);
              }
            }
          });
        });
    });
  }

  public getProductType(purpose) {
    for (let i = 0; i < this.loanPurposes.length; i++) {
      if (this.loanPurposes[i].id === purpose) {
        return this.loanPurposes[i]['productType'];
      }
    }
  }

  public getVxProducts() {
    console.log('getVxProducts');
    console.log('[broker]', this.broker);
    console.log('[purpose]', this.formGroup.value.purpose);
    console.log('[collateral]', this.formGroup.value.vehicle);

    if (this.broker && this.formGroup.value.purpose && this.formGroup.value.vehicle && this.formGroup.value.vehicle.year) {
      this.productService.getMotorVehicleVariationsList(this.getProductType(this.formGroup.value.purpose), this.broker.id, this.formGroup.value.purpose, this._securityType, this._collateral.year)
        .subscribe((results) => {
            // console.log('[getVxProducts]', results);
            if (results && results.length) {
              this.updateMaxLoanAmounts(this.formGroup.get('totalLoanAmount') as UntypedFormControl, results[0].minLoan, results[0].maxLoan);
              this.formGroup.get('product').setValue(results[0].slug, {emitEvent: false});
              this.formGroup.get('productName').setValue(results[0].name, {emitEvent: false});
              this.populateLoanTerms(results[0].pricing[0].rates);
              this.populateBalloons();

              if (this.formGroup.get('allowCards')) {
                this.formGroup.get('allowCards').patchValue(results[0].allowCards);
              }
            } else {
              console.log('No products found', results);
            }
          },
          (err) => {
            console.log(err);
          });
    }
  }

  public populateLoanTerms(rates) {
    this.loanTerms = [];
    rates.forEach((rate) => {
      const term = {
        slug: rate.term.value + '-' + rate.term.unit,
        name: rate.term.value + ' ' + rate.term.unit,
        rate: rate
      };
      this.loanTerms.push(term);
    });
    this.enableLoanTerms = true;
  }

  public updateMaxLoanAmounts(control: UntypedFormControl, min: number, max: number) {
    console.log('update max amounts');
    const validators = [];
    if (min && min > 0) {
      validators.push(Validators.min(min));
    }
    if (max && max > 0) {
      validators.push(Validators.max(max));
    }
    control.setValidators(validators);
  }

  public updateTerm(slug) {
    console.log('[updateTerm]', slug, this.loanTerms);

    const matchingTerm = this.loanTerms.find(t => t.slug === slug);
    if (matchingTerm) {
      this.rateService.setRateParameters(
        {
          termInYears: matchingTerm.rate.term.value, // hopefully this is always in years?
          baseRate: new Decimal(matchingTerm.rate.rtb).toNumber()
        });
      this.loanTermInYears = Number(matchingTerm.rate.term.value);
    }

    this.loanTerms.forEach((term) => {
      if (term.slug === slug) {
        this.formGroup.get('loanTerm').setValue(term);
        this._loanTerm = term;
        this.populateBalloons();
      }
    });
  }

  initSubscriptions() {

    this.toggleBrokerageFees(this.formGroup.value.brokerageFeeCheck);
    this.toggleOriginatorFee(this.formGroup.value.originationFeeCheck);

    this.formGroup.get('purchaseRefinanceAmount').valueChanges.pipe(
      debounceTime(500))
      .subscribe(val => {
          console.debug('QuoteDetailsComponent.initSubscriptions.purchaseRefinanceAmount');
          this.calculateSubtotal();
          this.calculateBalloon();
          this.calculateBrokerage('brokerageFee');
          this.rateService.setRateParameters({totalLoanAmount: val});
        }
      );

    this.formGroup.get('depositTradeAmount').valueChanges.pipe(
      debounceTime(500))
      .subscribe(val => {
          console.debug('QuoteDetailsComponent.initSubscriptions.depositTradeAmount');
          this.calculateSubtotal();
        }
      );

    this.formGroup.get('originationFee').valueChanges.pipe(
      debounceTime(500))
      .subscribe(val => {
          console.debug('QuoteDetailsComponent.initSubscriptions.originationFee');
          this.calculateSubtotalAndFees();
        }
      );

    this.formGroup.get('brokerageFeePercentage').valueChanges.pipe(
      debounceTime(1500))
      .subscribe(
        val => {
          console.debug('QuoteDetailsComponent.initSubscriptions.brokerageFeePercentage');
          if (!this._brokerageUpdated) {
            this.calculateBrokerage('brokerageFeePercentage');
          } else {
            this._brokerageUpdated = false;
          }
        }
      );

    this.formGroup.get('balloonAmount').valueChanges.pipe(
      debounceTime(500))
      .subscribe(
        val => {
          console.debug('QuoteDetailsComponent.initSubscriptions.balloonAmount');
          // if balloon amount has changed manually
          if (this.formGroup.get('purchaseRefinanceAmount').value) {
            const value = +(Number(val) / Number(this.formGroup.get('purchaseRefinanceAmount').value || 0) * 100).toFixed(2);
            // get the maximum balloon % first
            const max = this.allBalloons[this.allBalloons.length - 1];

            if (Number(value) > max) {
              this.formGroup.get('balloonPercentage').patchValue(max, {emitEvent: false});
              this.calculateBalloon();
              return;
            }

            if (this.allBalloons.indexOf(value) === -1 && value) {
              this.allBalloons.push(value);
              this.allBalloons = this.allBalloons.sort((a, b) => a - b);
            }
            this.formGroup.get('balloonPercentage').patchValue(value, {emitEvent: false});
            this.rateService.setRateParameters({balloonAmount: Number(val)});
          }
        }
      );

    this.formGroup.get('brokerageFee').valueChanges.pipe(
      debounceTime(1500))
      .subscribe(
        val => {
          console.debug('QuoteDetailsComponent.initSubscriptions.brokerageFee');
          if (!this._brokerageUpdated) {
            this.calculateBrokerage('brokerageFee');
          } else {
            this._brokerageUpdated = false;
          }
        }
      );
  }

  toggleBrokerageFees(value) {
    if (value) {
      this.formGroup.get('brokerageFeePercentage').clearValidators();
      this.formGroup.get('brokerageFeePercentage').patchValue(0);
      this.formGroup.get('brokerageFeePercentage').disable();
      this.formGroup.get('brokerageFeePercentage').updateValueAndValidity();
      this.formGroup.get('brokerageFee').patchValue(0);
      this.formGroup.get('brokerageFee').disable();
      this.formGroup.get('brokerageFee').clearValidators();
      this.formGroup.get('brokerageFee').updateValueAndValidity();
    } else {
      this.formGroup.get('brokerageFee').enable();
      this.formGroup.get('brokerageFee').updateValueAndValidity();
      this.formGroup.get('brokerageFeePercentage').enable();
      this.formGroup.get('brokerageFeePercentage').updateValueAndValidity();
      this.updateMaxBrokerageAmount();
    }
  }

  toggleOriginatorFee(value) {
    if (value) {
      this.formGroup.get('originationFee').clearValidators();
      this.formGroup.get('originationFee').updateValueAndValidity();
      this.formGroup.get('originationFee').patchValue(0);
      this.formGroup.get('originationFee').disable();
    } else {
      this.formGroup.get('originationFee').enable();
      this.formGroup.get('originationFee').setValidators(new QuoteDetailsModel().originationFee.validation);
      this.formGroup.get('originationFee').updateValueAndValidity();
    }
  }

  calculateSubtotal() {
    // console.log('[calculateSubtotal]');
    this._subtotal = this.formGroup.get('purchaseRefinanceAmount').value - this.formGroup.get('depositTradeAmount').value;
    this.formGroup.get('subTotal').patchValue(this._subtotal);
    this.processInsurances();
    this.calculateSubtotalAndFees();
  }

  calculateSubtotalAndFees() {
    this._totalFees = this.formGroup.get('applicationFee').value + this.formGroup.get('originationFee').value + this._totalInsurance;
    this.formGroup.get('subtotalWithFees').patchValue(this._subtotal + this._totalFees);

    // validate if sum of insurances don't exceed 10% of purchase price
    const ratio = (this._totalInsurance / this.formGroup.get('purchaseRefinanceAmount').value) * 100;
    if (ratio > 10) {
      this.formGroup.get('subtotalWithFees').setErrors({'invalid': true});
    } else {
      this.formGroup.get('subtotalWithFees').setErrors(null);
    }

    this.calculateLoanAmount();
  }

  calculateBrokerage(source) {
    let value = 0;
    if (this.formGroup.get('purchaseRefinanceAmount').value > 0) {
      switch (source) {
        case 'brokerageFeePercentage':
          value = (this._subtotal * this.formGroup.get('brokerageFeePercentage').value) / 100;

          this._brokerageUpdated = true;
          this.formGroup.get('brokerageFee').patchValue(value.toFixed(2));
          break;

        case 'brokerageFee':
          value = ((this.formGroup.get('brokerageFee').value / this._subtotal) * 100);

          this._brokerageUpdated = true;
          this.formGroup.get('brokerageFeePercentage').patchValue(value.toFixed(5));
          break;
      }

      this.calculateLoanAmount();
    }
  }

  calculateLoanAmount() {
    this.totalLoanAmount = this._subtotal + this._totalFees;
    if (!this.dialDownEnabled) {
      this.totalLoanAmount = this.totalLoanAmount + Number(this.formGroup.get('brokerageFee').value);
    }
    this.formGroup.get('totalLoanAmount').patchValue(this.totalLoanAmount.toFixed(2));
  }

  public populateRepaymentTypes() {
    this.repaymentTypes.push({
      id: 'monthly',
      text: 'Monthly',
    });
    this.formGroup.get('repaymentFrequency').patchValue('monthly', {emitEvent: false});
  }

  public populateBalloons() {
    if (this._selectedPurpose && this._collateral && this._collateral.year && this.vehicleAge < 5 && this._loanTerm && this._loanTerm.rate.term.value < 6) {
      this.productService.getBalloons(this.getProductType(this._selectedPurpose), this._selectedPurpose, this._collateral.year, this._loanTerm.rate.term.value)
        .subscribe((results) => {
          this.allBalloons = [];
          if (results) {
            this.allBalloons = results;
            this.disableBalloons = false;

            const max = results[results.length - 1] || 0;
            // if currently selected balloon is no longer allowed
            const curPercentage = this.formGroup.get('balloonPercentage').value;
            console.log(curPercentage, max);
            if (results.indexOf(curPercentage) === -1) {
              if (curPercentage <= max) {
                if (this.allBalloons.indexOf(curPercentage) === -1 && curPercentage) {
                  this.allBalloons.push(curPercentage);
                  this.allBalloons = this.allBalloons.sort((a, b) => a - b);
                }
              } else {
                this.formGroup.get('balloonPercentage').setValue(0, {emitEvent: false});
                this.formGroup.get('balloonAmount').reset({value: 0, disabled: false}, {emitEvent: false});
              }
            }
          } else {
            // defaults to 0
            this.allBalloons.push(0);
            this.formGroup.get('balloonPercentage').setValue(0, {emitEvent: false});
            this.disableBalloons = false;
          }
        });
      this.formGroup.get('balloonAmount').reset({value: 0, disabled: false}, {emitEvent: false});
    } else {
      this.disableBalloons = (this.vehicleAge > 4 || this._loanTerm.rate.term.value > 5);
      this.formGroup.get('balloonPercentage').setValue(0, {emitEvent: false});
      this.formGroup.get('balloonAmount').reset({value: null, disabled: true}, {emitEvent: false});
    }
  }

  public calculateBalloon() {
    const value = +(Number(this.formGroup.get('purchaseRefinanceAmount').value) * (Number(this.formGroup.get('balloonPercentage').value) / 100)).toFixed(2);
    this.formGroup.get('balloonAmount').patchValue(value.toString());
    this.rateService.setRateParameters({balloonAmount: value});
  }

  public getPurposeNameBySlug(slug) {
    // console.log('[getPurposeNameBySlug]', slug);
    let name = '';
    this.loanPurposes.forEach((p) => {
      if (p.id === slug) {
        name = p.text;
      }
    });
    return name;
  }

  public processInsurances() {
    this._totalInsurance = 0;
    this.insurancesFormArray.controls.forEach((insurance, i) => {
      if (insurance.value.insuranceAmount && !insurance.value.insuranceId) {
        // check insurance name, if amount is given
        this.insurancesFormArray.controls[i].get('insuranceId').setErrors({invalid: true});
      } else if (insurance.value.insuranceId && insurance.value.insuranceAmount < 1) {
        // check amount, if insurance is selected
        this.insurancesFormArray.controls[i].get('insuranceAmount').setErrors({invalid: true});
      } else {
        this._totalInsurance += parseInt(insurance.value.insuranceAmount, 10);
      }
    });
    this.rateService.setRateParameters({capitalisedPurposes: this._totalInsurance});
    this.calculateSubtotalAndFees();
  }

  setSecurityType(purpose) {
    switch (purpose) {
      case 'purchase-new-business':
      case 'purchase-new-personal':
        this._securityType = 'new';
        break;

      case 'purchase-used-business':
      case 'purchase-used-personal':
        this._securityType = 'used-dealer';
        break;

      case 'refinance-personal':
        this._securityType = 'used-private';
        break;

      default:
        this._securityType = 'used-dealer';
    }
    this.formGroup.get('securityType').patchValue(this._securityType, {emitEvent: false});
  }
}
